// extracted by mini-css-extract-plugin
export default {"Container":"PatternPage_Container__yk85N","Card":"PatternPage_Card__i3q6z","Image":"PatternPage_Image__Ny6mo","TopContent":"PatternPage_TopContent__3SrD8"};